import { Component, OnInit } from '@angular/core';
import { Company } from '../../model/company';
import { Router, ActivatedRoute } from '@angular/router';
import { DBService } from '../../services/db.service';
import { LocationService } from '../../services/location.service';

import * as firebase from 'firebase';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { AuthenticationService } from '../../services/authentication.service';
import { User } from '../../model/user';
import { Partner } from '../../model/partner';
import { Employee } from '../../model/employee';
import { Segment } from '../../model/segments';

declare var $: any;

declare var Materialize: any;

@Component({
  selector: 'app-edit-company',
  templateUrl: './edit-company.component.html',
  styleUrls: ['./edit-company.component.css'],
  providers: [DBService, LocationService]
})
export class EditCompanyComponent implements OnInit {

  phoneMask = ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  cepMask = [/[1-9]/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];
  public cnpjMask = [/[0-9]/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];
  dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];

  company: Company;
  uid: string;

  initLoading: boolean;
  loading: boolean;

  isUploadingFile: boolean;
  isUploadingLogo: boolean;

  isSaving: boolean;
  isSearching: boolean;

  user: User;

  newProduct: string;

  companies: Company[];
  partners: Partner[];

  isIGanhei: boolean;

  segments: Segment[];

  contacts: Employee[];

  constructor(private router: Router, private dbService: DBService, private route: ActivatedRoute, private locationService: LocationService, private authService: AuthenticationService) {
    this.initLoading = true;
    this.company = new Company();
    this.company.products = [];

    this.loadUser();

    this.loadCompanies();
  }

  private loadContacts() {
    this.dbService.listWithUIDs<Employee>('/employees')
      .then(list => {
        this.contacts = list.filter(item => item.companyUID === this.company.uid);;
      })
      .catch(error => console.log(error));
  }

  private loadSegments() {
    this.dbService.listWithUIDs<Segment>('segments')
      .then(segments => {
        this.segments = segments;
        this.loading = false;
      });
  }

  private loadCompanies() {
    this.dbService.listWithUIDs<Company>('/companies')
      .then(companies => {
        this.companies = companies;

        this.loadPartners();
      })
      .catch(error => console.log(error));
  }

  private loadPartners() {
    this.dbService.listWithUIDs<Partner>('/partners')
      .then(partners => {
        this.partners = partners;

        this.route.params
          .subscribe(params => this.initData(params['id']));
      })
      .catch(error => console.log(error));
  }

  ngOnInit() {
    $( function() {
      $( ".datePicker" ).datepicker({
        dateFormat: 'dd/mm/yy',
        dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
        dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S', 'D'],
        dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb', 'Dom'],
        monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
        monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
        nextText: 'Proximo',
        prevText: 'Anterior'
      });
    } );
  }

  private loadUser() {
    this.authService.getCurrentUser().subscribe(currentUser => {
      this.user = new User();

      if (currentUser != null) {
        this.user.uid = currentUser.uid;
        this.user.email = currentUser.email;

        this.loadEmployee();
      }
    });
  }

  private loadEmployee() {
    this.dbService.getObject<Employee>(`/employees/${this.user.uid}`)
      .then(employee => {
        this.isIGanhei = this.user.email.includes('@iganhei.com') || employee.companyUID === 'I-Ganhei';
      })
      .catch(error => console.log(error));
  }

  private initData(uid: string) {
    this.uid = uid;

    this.company = this.companies.filter(c => c.uid === uid)[0];

    this.loadContacts();
    this.loadSegments();

    this.companies = this.companies.filter(c => c.uid !== uid);

    if (this.company.products == null) {
      this.company.products = [];
    }

    this.initLoading = false;

    this.updateTextFields();
  }

  private updateTextFields() {
    setTimeout(() => Materialize.updateTextFields(), 100);
  }

  private save() {
    this.loading = true;

    if (!this.company.isInactive) {
      this.company.isInactive = false;
    }

    const updatingObj: any = {
      cnpj: this.company.cnpj,
      contractDateString: this.company.contractDateString,
      contractDate: this.company.contractDate,
      fee: this.company.fee,
      firstFeeDate: this.company.firstFeeDate,
      firstFeeDateString: this.company.firstFeeDateString,
      name: this.company.name,
      source: this.company.source,
      segmentUID: this.company.segmentUID,
      isInactive: this.company.isInactive,
      contractTime: this.company.contractTime,
      address: {
        cep: this.company.address.cep,
        city: this.company.address.city,
        neighborhood: this.company.address.neighborhood,
        number: this.company.address.number,
        state: this.company.address.state,
        street: this.company.address.street
      }
    };

    if (this.company.photoURL) {
      updatingObj['photoURL'] = this.company.photoURL;
    }

    if (this.company.headerLogo) {
      updatingObj['headerLogo'] = this.company.headerLogo;
    }

    if (this.company.products.length > 0) {
      updatingObj.products = this.company.products;
    }

    if (this.company.contractCancelDate) {
      updatingObj.contractCancelDateString = this.company.contractCancelDateString;
      updatingObj.contractCancelDate = this.company.contractCancelDate;
    }

    const properties = ['otherComment', 'metaField', 'searchID', 'indicatingCustomerUID', 'indicatingPartnerUID', 'paymentType',
    'firstMonthDate', 'firstMonthDateString', 'lastMonthDate', 'lastMonthDateString',
    'firstCommissionDate', 'firstCommissionDateString', 'lastCommissionDate', 'lastCommissionDateString', 'commission', 'salesPerson',
     'salesPersonCommission', 'manager', 'managerCommission', 'consultingPerson', 'consultingPersonCommission', 'operationsManager',
    'operationsManagerCommission'];

    this.setPropertyIfItIsNotNull(updatingObj, properties);

    this.dbService.update(`companies/${this.uid}`, updatingObj)
    .then(() => this.saveSuccess())
    .catch(error => console.log(error));
  }

  private setPropertyIfItIsNotNull(updatingObj, properties: string[]) {
    properties.forEach(p => {
      if (this.company[p] != null && this.company[p] != '' && this.company[p] != 0) {
        updatingObj[p] = this.company[p];
      }
    });
  }

  private saveSuccess() {
    this.loading = false;

    Materialize.toast('Empresa atualizada com sucesso', 2000);

    this.router.navigate(['/empresas']);
  }

  cancel() {
    this.router.navigate(['/empresas']);
  }

  searchCep() {
    this.isSearching = true;

    this.locationService.getAddress(this.company.address.cep)
      .then(address => {
        address.cep = this.company.address.cep;
        this.company.address = address;
        this.isSearching = false;

        this.updateTextFields();
      })
      .catch(error => {
        console.log(error);
        this.isSearching = false;
      });
  }

  public fileChangeEvent(fileInput: any) {
    if (fileInput.target.files && fileInput.target.files[0]) {
      this.uploadImage();
    }
  }

  public logoChangeEvent(logoInput: any) {
    if (logoInput.target.files && logoInput.target.files[0]) {
      this.uploadImageLogo();
    }
  }

  uploadImage() {
    this.isUploadingFile = true;
    const storage = firebase.storage().ref();
    const path = '/restaurants/';
    const files = [(<HTMLInputElement>document.getElementById('image')).files[0]];

    for (const image of files) {
      storage.child(path + image.name).put(image)
        .then((result) => {
          this.company.photoURL = result.downloadURL;
          this.isUploadingFile = false;
      });
    }
  }

  uploadImageLogo() {
    this.isUploadingLogo = true;
    const storage = firebase.storage().ref();
    const path = '/header-logo/';
    const files = [(<HTMLInputElement>document.getElementById('logo')).files[0]];

    for (const image of files) {
      storage.child(path + image.name).put(image)
        .then((result) => {
          this.company.headerLogo = result.downloadURL;
          this.isUploadingLogo = false;
      });
    }
  }

  onChangeContract(event) {
    const dateParts = this.company.contractDateString.split('/');

    const date = new Date(dateParts[1] + '-' + dateParts[0] + '-' + dateParts[2]);

    if (date.toString() === 'Invalid Date') {
      delete this.company.contractDate;
    } else {
      this.company.contractDate = date.getTime();
    }
  }

  onChangeFirstFee(event) {
    const dateParts = this.company.firstFeeDateString.split('/');

    const date = new Date(dateParts[1] + '-' + dateParts[0] + '-' + dateParts[2]);

    if (date.toString() === 'Invalid Date') {
      delete this.company.firstFeeDate;
    } else {
      this.company.firstFeeDate = date.getTime();
    }
  }

  onChangeCancel(event) {
    const dateParts = this.company.contractCancelDateString.split('/');

    const date = new Date(dateParts[1] + '-' + dateParts[0] + '-' + dateParts[2]);

    if (date.toString() === 'Invalid Date') {
      delete this.company.contractCancelDate;
    } else {
      this.company.contractCancelDate = date.getTime();
    }
  }

  addProduct() {
    this.company.products.push(this.newProduct);
    this.newProduct = '';
  }

  removeProduct(product) {
    this.company.products = this.company.products.filter(p => p !== product);
  }

  onChangeDate(event, propertyString, propertyDate) {
    const dateParts = this.company[propertyString].split('/');

    const date = new Date(dateParts[1] + '-' + dateParts[0] + '-' + dateParts[2]);

    if (date.toString() === 'Invalid Date') {
      delete this.company[propertyDate];
    } else {
      this.company[propertyDate] = date.getTime();
    }
  }

  changeSource() {
    this.company.salesPerson = '';
    this.company.salesPersonCommission = '';
    this.company.manager = '';
    this.company.managerCommission = '';

    this.company.otherComment = '';

    this.company.indicatingCustomerUID = '';

    this.company.indicatingPartnerUID = '';
    this.company.paymentType = 0;

    this.company.firstMonthDate = null;
    this.company.firstMonthDateString = '';
    this.company.lastMonthDate = null;
    this.company.lastMonthDateString = '';

    this.company.firstCommissionDate = null;
    this.company.firstCommissionDateString = '';
    this.company.lastCommissionDate = null;
    this.company.lastCommissionDateString = '';
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/edit-company/edit-company.component.ts